__turbopack_context__.v({
  "accent": "grRzaG_accent",
  "accentIcon": "grRzaG_accentIcon",
  "accentIcontype_error": "grRzaG_accentIcontype_error",
  "accentIcontype_success": "grRzaG_accentIcontype_success",
  "accentIcontype_warning": "grRzaG_accentIcontype_warning",
  "accenttype_error": "grRzaG_accenttype_error",
  "accenttype_success": "grRzaG_accenttype_success",
  "accenttype_warning": "grRzaG_accenttype_warning",
  "close": "grRzaG_close",
  "closeIcon": "grRzaG_closeIcon",
  "text": "grRzaG_text",
  "text___1U6ZH": "grRzaG_text___1U6ZH",
  "text__c2FXg": "grRzaG_text__c2FXg",
  "toast": "grRzaG_toast",
  "wrapper": "grRzaG_wrapper",
});
